import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  selectComponentAuthorized,
  selectUserType,
} from '../../../layout/store/slice'
import { AUTHORIZATION_TYPE } from '../../../utils/authorization'
import { AuthorizationLayout } from '../../common/html/AuthorizationLayout'
import { LayoutPanel } from '../../common/html/LayoutPanel'
import { Popular } from './Popular'
import { Recently } from './Recently'
import { loadingRecentlyAndPopular } from './store/slice'
import { getMostPopular, getRecentlyViewed } from './store/thunk'

export const RecentlyAndPopular = () => {
  const dispatch = useDispatch()

  const locale = useSelector((state) => state.i18n.locale)
  const loadingMostPopular = useSelector(
    loadingRecentlyAndPopular('mostPopular'),
  )
  const loadingRecentlyViewed = useSelector(
    loadingRecentlyAndPopular('recentlyViewed'),
  )
  const AUTHORIZATION = useSelector(selectComponentAuthorized)
  const userType = useSelector(selectUserType)

  const allowPopular =
    AUTHORIZATION.dashboard.mostPopularOnFiinGate[userType.userTypeId] ===
    AUTHORIZATION_TYPE.ALLOW

  const allowRecently =
    AUTHORIZATION.dashboard.recentlyViewed[userType.userTypeId] ===
    AUTHORIZATION_TYPE.ALLOW

  useEffect(() => {
    if (allowPopular) {
      dispatch(
        getMostPopular({
          NumberOfCompany: 10,
        }),
      )
    }
    if (allowRecently) {
      dispatch(getRecentlyViewed())
    }
  }, [locale])

  return (
    <LayoutPanel
      loading={
        (loadingMostPopular && allowPopular) ||
        (loadingRecentlyViewed && allowRecently)
      }
    >
      <div className="dFlex gap1 h100">
        <div className="w50">
          <AuthorizationLayout
            id="mostPopularOnFiinGate"
            title="dashboard.recentlyAndPopular.titlePopular"
          >
            <Popular />
          </AuthorizationLayout>
        </div>
        <div className="w50">
          <AuthorizationLayout
            id="recentlyViewed"
            title="dashboard.recentlyAndPopular.titleRecently"
          >
            <Recently />
          </AuthorizationLayout>
        </div>
      </div>
    </LayoutPanel>
  )
}
